
export type ModusType =
    | 'Working'
    | 'Pause'
    | 'Stopped'
    | 'Not Started'
    | 'Ended'
    | 'Day running'
    | 'Day end'
    ;

export const ModusContentMap: Record<ModusType, JSX.Element> = {
    Working: (
        <div>
            🛠️ Arbeiten
        </div>
    ),
    Pause: (
        <div>
            🏖️ Pause
        </div>
    ),
    Stopped: (
        <div>
            ⏹️ Gestoppt
        </div>
    ),
    'Not Started': (
        <div>
            ⏳ Nicht gestartet
        </div>
    ),
    Ended: (
        <div>
            ✔️ Beendet
        </div>
    ),
    'Day running': (
        <div>
            ⏰ Tag läuft
        </div>
    ),
    'Day end': (
        <div>
            💤 Tag beendet
        </div>
    ),
};
